exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".j-vxe-progress.no-animation[data-v-c83018b8] .ant-progress-success-bg,\n.j-vxe-progress.no-animation[data-v-c83018b8] .ant-progress-bg {\n  -webkit-transition: none !important;\n  transition: none !important;\n}\n", ""]);

// exports
